import { ClearIcon } from "@au-schein-de/au-ui-library";

import {
	IconButton,
	Input,
	MagnifyingGlassIcon,
} from "@au-schein-de/au-ui-library";
import type { ChangeEvent, KeyboardEvent, ReactElement } from "react";

type SearchBarProps = {
	leftIcon?: ReactElement;
	autoFocus?: boolean;
	onChange: (event: ChangeEvent<HTMLInputElement>) => void;
	onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
	placeholder?: string;
	search: string;
	onRightIconClick?: () => void;
	dataTestId?: string;
	variant?: "search" | "default";
	className?: string;
	error?: string;
};

export function SearchBarBaseComponent({
	leftIcon,
	autoFocus,
	onChange,
	onKeyDown,
	placeholder,
	search,
	onRightIconClick,
	dataTestId,
	variant = "search",
	className,
	error,
}: SearchBarProps) {
	return (
		<Input
			autoFocus={autoFocus}
			className={className}
			data-testid={dataTestId ?? "search-bar"}
			leftIcon={
				leftIcon ?? <MagnifyingGlassIcon size={6} colorToken="gray-700" />
			}
			onChange={onChange}
			onKeyDown={onKeyDown}
			placeholder={placeholder}
			rightIcon={
				search !== "" ? (
					<IconButton
						icon={<ClearIcon size={4} />}
						onClick={onRightIconClick}
						shape="circle"
						size="sm"
						variant="input"
						data-testid="clear-search"
					/>
				) : undefined
			}
			value={search}
			variant={variant}
			error={error}
		/>
	);
}
